module.exports = __webpack_public_path__ + "static/media/10-1.1ab14834.mp3";